<template>
    <div class="fm-container">
        <Backer />

        <!-- <div>
            <b-alert show variant="warning" style="padding: 2px; text-align: right;">
                <b-button variant="success" size="sm" @click="importFromExcel">IMPORT FROM EXCEL</b-button>
            </b-alert>
        </div> -->

        <div>
            <div style="display: inline-block; width: 100%; text-align: center; margin-bottom: 10px; margin-top: 10px; padding: 5px; background: #efefef;">
                <span style="display: inline-block; margin: 5px; font-size: 13px;">Pick Category</span>
                <span style="display: inline-block; margin: 5px;">
                <b-form-select
                    v-model="category_id"
                    :options="categories"
                    size="sm"
                    @change="setCategoryAndLoad"
                ></b-form-select>
                </span>
            </div>
        </div>

        <b-overlay :show="loading_rows" rounded="sm" style="margin-top: 10px;">
            <div style="display: inline-block; margin-bottom: 5px;">
                <b-button variant="secondary" size="sm" v-on:click="addRow">Add Row</b-button>
            </div>
            <div style="max-height: 900px;" v-if="rows.length > 0">
                <!-- <b-alert show style="padding:5px; margin: 0px;">
                    <div style="display: inline-block;"><b>Products</b></div>

                    <div style="display: inline-block; margin-bottom: 5px;">
                        <b-button variant="secondary" size="sm" v-on:click="addRow">Add Row</b-button>
                    </div>
                </b-alert> -->
                
                <vue-good-table
                      :columns="columns"
                      @on-cell-click="onColumnClick"
                      :rows="rows"
                      :pagination-options="{
                        enabled: true,
                        mode: 'pages',
                        position: 'top',
                        perPage: 20
                      }"
                      :search-options="{
                        enabled: true,
                        trigger: 'enter'
                      }"
                      :select-options="{ enabled: false }"
                      styleClass="vgt-table bordered condensed"
                    > 
            
                    <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'actions'">
                            <span>
                                <span v-if="props.row.row_status == 'not added'">
                                    <b-button variant="outline-success" size="sm">Add</b-button>
                                </span>

                                <span v-else>
                                    <b-button variant="outline-primary" size="sm">Update</b-button>
                                    <b-button variant="outline-primary" size="sm" style="visibility: hidden;"> </b-button>
                                </span>
                            </span>
                        </span>

                        <span v-else-if="props.column.field == 'product_name'">
                            <b-input v-model="rows[props.row.originalIndex].product_name" size="sm" style="width: 300px;"></b-input>
                        </span>

                        <span v-else-if="props.column.field == 'sku'">
                            <b-input v-model="rows[props.row.originalIndex].sku" size="sm" style="width: 200px;"></b-input>
                        </span>

                        <span v-else-if="props.column.field == 'category_id'">
                            <b-form-select
                                v-model="rows[props.row.originalIndex].category_id"
                                :options="categories"
                                size="sm"
                            ></b-form-select>
                        </span>

                        <span v-else-if="props.column.field == 'vendor_id'">
                            <b-form-select
                                v-model="rows[props.row.originalIndex].vendor_id"
                                :options="vendors"
                                size="sm"
                            ></b-form-select>
                        </span>

                        <span v-else-if="props.column.field == 'landed_cost'">
                            <b-input v-model="rows[props.row.originalIndex].landed_cost" size="sm" type="number" min="0" style="width:70px; margin: auto;"></b-input>
                        </span>

                        <span v-else-if="props.column.field == 'wholesale_price'">
                            <b-input v-model="rows[props.row.originalIndex].wholesale_price" size="sm" type="number" min="0" style="width:70px; margin: auto;"></b-input>
                        </span>

                        <span v-else-if="props.column.field == 'selling_price'">
                            <b-input v-model="rows[props.row.originalIndex].selling_price" size="sm" type="number" min="0" style="width:70px; margin: auto;"></b-input>
                        </span>

                        <span v-else-if="props.column.field == 'status'">
                            <b-form-select
                                v-model="rows[props.row.originalIndex].status"
                                :options="product_status"
                                size="sm"
                            ></b-form-select>
                        </span>

                        <span v-else>
                            {{props.formattedRow[props.column.field]}}
                        </span>
                    </template>
                </vue-good-table>
            </div> 
        </b-overlay>

    </div>
</template>

<script>
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'

    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table'

    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'

    import readXlsxFile from 'read-excel-file'

    export default {
        name: "ListProducts",
        props: [],
        components: {Backer,Multiselect,VueGoodTable,readXlsxFile},
        data: function(){
            return {
                userDetails: {},
                category_id: null,
                loading_rows: false,
                rows: [],
                categories: [],
                vendors: [],
                product_status: [
                    {value: "active", text: "ACTIVE"},
                    {value: "discontinued", text: "DISCONT."},
                ],
                columns: [
                    {
                        label: "ID",
                        field: "id",
                        filterable: false,
                        sortable: true,
                        type: "number"
                    },
                    {
                        label: "SKU",
                        field: "sku",
                        filterable: true,
                        sortable: false,
                    },
                    {
                        label: "Name",
                        field: "product_name",
                        filterable: true,
                        sortable: false,
                    },
                    {
                        label: "Category",
                        field: "category_id",
                        filterable: false,
                        sortable: true,
                        type: "number"
                    },
                    {
                        label: "Vendor",
                        field: "vendor_id",
                        filterable: true,
                        sortable: true,
                        type: "number"
                    },
                    {
                        label: "L Cost",
                        field: "landed_cost",
                        filterable: false,
                        sortable: true,
                        type: "number"
                    },
                    {
                        label: "W Price",
                        field: "wholesale_price",
                        filterable: false,
                        sortable: true,
                        type: "number"
                    },
                    {
                        label: "S Price",
                        field: "selling_price",
                        filterable: false,
                        sortable: true,
                        type: "number"
                    },
                    {
                        label: "Status",
                        field: "status",
                        filterable: false,
                        sortable: true,
                    },
                    {
                        label: "Row status",
                        field: "row_status",
                        filterable: false,
                        sortable: false,
                        type: "html"
                    },
                    {
                        label: "Actions",
                        field: "actions",
                        filterable: false,
                        sortable: false,
                        type: "html"
                    }
                ]
            }
        },
        methods: {
            setCategoryAndLoad: function(e){
                this.category_id = e;
                this.rows = [];
                this.fetch_products();
            },
            importFromExcel: function(e){
                if (e){
                    e.preventDefault();
                }

            },
            onColumnClick: function(params){
                let action = params.event.target.innerText;
                
                if (action === "Remove") {
                    let value = params.row.idx;
                    this.removeRow(value);
                }

                else if (action === "Add") {
                    this.submitRow(params, "add");
                }

                else if (action === "Update") {
                    this.submitRow(params, "update");
                }

                else {
                    console.log("NOOO")
                }
            },
            addRow: function(e){
                if (e){
                    e.preventDefault();
                }

                // if (this.rows.length > 200){
                //     this.$bvToast.toast(
                //         "Cannot add more than 200 products a time. Please split products into multiple batches.", 
                //         {title: "Error", autoHideDelay: 1500, variant:"danger"}
                //     );
                //     return
                // }

                let idx = 0;
                if (this.rows.length > 0){
                    idx = this.rows[0].idx+1;
                }

                let empty_element = {
                    idx: idx,
                    product_name: null,
                    sku: null,
                    category_id: null,
                    vendor_id: null,
                    landed_cost: 0.0,
                    selling_price: 0.0,
                    wholesale_price: 0.0,
                    status: null,
                    row_status: 'not added'
                }
                this.rows.splice(0,0, empty_element);
            },
            removeRow: function(idx){
                let rows_temp = this.rows.filter(function(d){return d.idx != idx});
                this.rows = rows_temp;
            },
            fetch_prereqs: function(){
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/product/category/all/",
                        data: {},
                        type: "secure",
                        executable: Requestor.getAsyncP,
                        s: function(response){
                            if (response.data.result){
                                that.categories = response.data.result.map(function(d){
                                    return {value: d[0], text: d[1]}
                                });
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error);
                            that.$bvToast.toast(
                                "Error loading categories.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                    {
                        path:  "/api/product/vendor/all/",
                        data: {},
                        type: "secure",
                        executable: Requestor.getAsyncP,
                        s: function(response){
                            if (response.data.result){
                                that.vendors = response.data.result.map(function(d){
                                    return {value: d[0], text: d[1]}
                                });
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            that.$bvToast.toast(
                                "Error loading vendors list.", 
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    }
                ]

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f);
                    }
                }
            },
            fetch_products: function(e){
                if (e){
                    e.preventDefault();
                }
                let that = this;
                let path = "/api/product/get_all/";
                let data = {category_id: this.category_id};

                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.rows = response.data.result;
                    }
                    that.loading_rows = false;
                }

                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading products.", 
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.loading_rows = false;
                }
                this.loading_rows = true;
                Requestor.getAsyncP(path, data, this, s, f);
            },
            submitRow: function(params, action){
                let that = this;
                let row = params.row;
                let idx = row.idx;
                let origidx = row.originalIndex;
                row.landed_cost = parseFloat(row.landed_cost);
                row.wholesale_price = parseFloat(row.wholesale_price);
                row.selling_price = parseFloat(row.selling_price);

                // if (row.category_id != this.category_id) {
                //     this.$bvToast.toast(
                //         "Please pick the category as same of parent category.", 
                //         {title: "Error", autoHideDelay: 1500, variant:"warning"}
                //     );
                //     return
                // }

                let path = "";

                if (action == "add"){
                    path = "/api/product/add_product/";
                }
                else if (action == "update"){
                    path = "/api/product/update_product/";
                }
                else {
                    this.$bvToast.toast(
                        "Action not performed. Nothing changed.", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    return
                }

                let data = {"product": row};
                let s = function(response){
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    else {
                        that.rows[origidx] = response.data.result;
                        that.rows[origidx].row_status = "added"
                        let temp_rows = JSON.parse(JSON.stringify(that.rows));

                        if (action == "add"){
                            that.$bvToast.toast(
                                "Added product.", 
                                {title: "Success", autoHideDelay: 1500, variant:"success"}
                            );
                        }
                        else if (action == "update"){
                            that.$bvToast.toast(
                                "Updated product.", 
                                {title: "Success", autoHideDelay: 1500, variant:"success"}
                            );
                        }
                        
                        that.rows = [];
                        that.rows = temp_rows;
                    }
                }
                let f = function(error){
                    console.log(error);
                    that.$bvToast.toast(
                        "Error adding product. Please try again", 
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }

                Requestor.postAsyncP(path, data, this, s, f);

            }
        },
        created: function(){
            let userDetails = localStorage.userDetails;
            if (userDetails){
                this.userDetails = JSON.parse(userDetails);
                console.log(this.userDetails);
                if (this.userDetails.userrole == "admin"){
                    this.fetch_prereqs();
                }
                else {
                    this.$router.replace({"path":  "/"})
                }
            }
        }
    }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/ListProducts.vue